export default "__VITE_ASSET__BDaiDaNT__"